import React from 'react'
import PropTypes from 'prop-types'
import Paper from '@material-ui/core/Paper'
import { withStyles} from '@material-ui/core/styles'
import {
  Grid, Table, TableHeaderRow
} from '@devexpress/dx-react-grid-material-ui'

const styles = {
  customCell: {
    whiteSpace: "normal",
    wordWrap: "break-word"
  }
}

const CustomTableCellBase = ({ classes, ...restProps }) => (
  <Table.Cell className={classes.customCell} {...restProps} />
)

const CustomTableBase = ({ style, ...restProps }) => (
  <Table.Table
    style={{
      ...style,
      minWidth: 0
    }}
    {...restProps}
  />
)

const CustomTableCell = withStyles(styles)(CustomTableCellBase);
const CustomTable = withStyles(styles)(CustomTableBase);

class DownloadTable extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      columns: [
        { name: "changeColumn", title: "Changes" }
      ],
      rows: [
        { changeColumn: 'Corrected spelling errors and renamed texts to increase understanding.'},
        { changeColumn: 'The buttons for registration are now always displayed under "Extended-> License" (not only for license changes)'},
        { changeColumn: 'The "Email Registration" and "Generate ID" buttons were reversed in their function.'},
        { changeColumn: 'Problems with changing and displaying Instar VGA and HD picture settings when switching channels have been fixed.'},
        { changeColumn: 'Problems with setting changes when using P2P cameras have been fixed.'},
        { changeColumn: 'The crash when recording when the recording path contains umlauts or other special characters has been fixed.'},
        { changeColumn: 'If unsupported channel bindings are selected, e.g. P2P no longer crashes the software when HTML5 is selected in the web client.'},
      ]
    };
  }
  render() {
    const { rows, columns } = this.state;

    return (
      <Paper style={{display: 'inline-block', maxWidth: '915px'}}>
        <Grid rows={rows} columns={columns}>
          <Table tableComponent={CustomTable} cellComponent={CustomTableCell} />
          <TableHeaderRow />
        </Grid>
      </Paper>
    );
  }
}

DownloadTable.propTypes = {
  classes: PropTypes.object.isRequired,
}


export default withStyles(styles)(DownloadTable)




// import React from 'react'
// import {Table, Column, Cell} from 'fixed-data-table-2'
// import '../../../../assets/styles/data_tables/fixed-data-table.css'


// const cameraRow = [
//   'Corrected spelling errors and renamed texts to increase understanding.',
//  'The buttons for registration are now always displayed under "Extended-> License" (not only for license changes)',
//  'The "Email Registration" and "Generate ID" buttons were reversed in their function.',
//  'Problems with changing and displaying Instar VGA and HD picture settings when switching channels have been fixed.',
//  'Problems with setting changes when using P2P cameras have been fixed.',
//  'The crash when recording when the recording path contains umlauts or other special characters has been fixed.',
//  'If unsupported channel bindings are selected, e.g. P2P no longer crashes the software when HTML5 is selected in the web client.',
// ]

// // Render your table
// const ConnectTable = () => {
//     return (
//       <Table
//         rowHeight={55}
//         rowsCount={cameraRow.length}
//         touchScrollEnabled={true}
//         width={850}
//         maxHeight={1000}
//         headerHeight={50}>
//         <Column
//           header={<Cell>Fixed Bugs</Cell>}
//           cell={({rowIndex, ...props}) => (
//             <Cell {...props}>
//               {cameraRow[rowIndex]}
//             </Cell>
//           )}
//           flexGrow={1}
//           width={850}
//         />
//       </Table>
//     )
// }

// export default ConnectTable